import axios from '@/utils/axios';
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        itemTypeGroupClass: null,
        itemTypeGroupClasses: []
    },
    mutations: {
        setItemTypeGroupClass(state, payload) {
            state.itemTypeGroupClass = payload;
        },
        setItemTypeGroupClasses(state, payload) {
            state.itemTypeGroupClasses = payload;
        },
        clearItemTypeGroupClasses(state) {
            state.itemTypeGroupClasses = [];
        }
    },
    actions: {
        storeItemTypeGroupClass({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `${rootState.warehouse.routePrefix}/item-type-group-classes`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    reject(error);
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                })
            });
        },
        updateItemTypeGroupClass({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `${rootState.warehouse.routePrefix}/item-type-group-classes/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    reject(error);
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                })
            });
        },
        removeItemTypeGroupClass({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/item-type-group-classes/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    reject(error);
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                })
            });
        },
        fetchItemTypeGroupClass({rootState, dispatch, commit}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/item-type-group-classes/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setItemTypeGroupClass', response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                })
            });
        },
        fetchItemTypeGroupClasses({rootState, dispatch, commit}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/item-type-group-classes?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setItemTypeGroupClasses', response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                })
            });
        },
        clearItemTypeGroupClasses({commit}) {
            commit('clearItemTypeGroupClasses');
        }
    }
}